import { IMedicalOrderRequest } from '@alberta/konexi-shared';
import { Inject, Injectable } from '@angular/core';
import { BaseComponentModel } from 'src/app/common/component-model/base-component-model';
import { ComponentModelDependencies } from 'src/app/common/component-model/component-model-dependencies';
import { ComponentModelInfo } from 'src/app/common/component-model/component-model-info';
import { MedicalOrderRequestModelName } from 'src/app/shared/models/model-names';

@Injectable({ providedIn: 'root' })
export class MedicalOrderRequestComponentModel extends BaseComponentModel<IMedicalOrderRequest> {
  /**
   * ComponentModel for all medicalOrderRequest relevant actions and dependencies
   */
  constructor(
    @Inject(ComponentModelDependencies) _componentModelDependencies: ComponentModelDependencies,
    @Inject(ComponentModelInfo) _componentModelInfo: ComponentModelInfo
  ) {
    super(MedicalOrderRequestModelName, _componentModelDependencies, _componentModelInfo);
  }
}
